import React, { useEffect, useState } from "react";
import CrearCartaForm from "./components/CrearCartaForm";
import Loader from "../general/Loader";
import Modal from "../general/Modal";
import Pagination from "../general/Pagination";
import Dropdown from "../general/Dropdown";
import FiltersContainer from "../general/FiltersContainer";
import PageHeader from "../general/PageHeader";
import useFilters from "../../hooks/useFilters";
import { request } from "../../utils/request";
import { apiRequest } from "../../hooks/apiRequest";
import { getLink, permisions, toast } from "../../utils/helpers";
import { auth } from "../../utils/auth";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

const Cartas = () => {
    const [loading, setLoading] = useState(false);
    const [cartas, setCartas] = useState({});
    const [selected, setSelected] = useState();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showGenerarModal, setShowGenerarModal] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const { handleFilterChange, filtersQuery } = useFilters({ buscar: null });

    const getCartas = async (url) => {
        url = url ? url + "&limit=15" : `cartas?limit=15`;

        setLoading(true);

        const response = await request(url);

        setCartas(response);

        setLoading(false);
    };

    const openGenerarModal = (template) => {
        setSelected(template);

        setShowGenerarModal(true);
    };

    const closeGenerarModal = (isCancel = false) => {
        setSelected();

        setShowGenerarModal(false);

        if (!isCancel) getCartas(`cartas${filtersQuery}`);
    };

    const openDeleteModal = (template) => {
        setSelected(template);

        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setSelected();

        setShowDeleteModal(false);
    };

    const eliminarCarta = async () => {
        setDeleting(true);

        const response = await apiRequest({}, `cartas/${selected.id}`, 'delete');

        if (response.success) {
            toast("Carta Eliminada", "success");
            
            closeDeleteModal();

            getCartas(`cartas${filtersQuery}`);
        } else {
            toast(response.data.message, "error");
        }

        setDeleting(false);
    };

    useEffect(() => {
        getCartas(`cartas${filtersQuery}`);
    }, [filtersQuery]);

    return <>
        <PageHeader title="Cartas">
            {auth.canEdit(permisions.verCartas) && <button
                className="au-btn au-btn-icon au-btn--green au-btn--small m-r-15 ml-auto mt-2 mt-lg-0"
                onClick={openGenerarModal}
            >
                <i className="zmdi zmdi-plus" />
                Nueva Carta
            </button>}
        </PageHeader>

        <FiltersContainer>
            <div className='col'>
                <label htmlFor='search'>Buscar</label>
                <input
                    name='buscar'
                    onChange={(e) => handleFilterChange("buscar", e?.target.value)}
                    type='search'
                    placeholder='Buscar...'
                    className='form-control'
                />
            </div>
        </FiltersContainer>

        <div className='row'>
            <div className='col-md-12'>
                <div>
                    <div className='table-data'>
                        <table className='table table-data2'>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Plantilla</th>
                                    <th>Contacto</th>
                                    <th>Fecha de Creación</th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody>
                                {loading
                                    ? (<tr className="tr-shadow"><td colSpan={5}><Loader /></td></tr>)
                                    : (cartas?.data?.length
                                        ? cartas.data.map((carta) => (<tr className="tr-shadow" key={carta.id}>
                                            <td>{carta.id}</td>
                                            <td>{carta.template.titulo}</td>
                                            <td>{carta.contacto.nombreCompleto ?? carta.contacto.nombre}</td>
                                            <td>{dayjs(carta.created_at).format("YYYY-MM-DD hh:mm a")}</td>
                                            <td style={{width: '128px'}}>{auth.canEdit(permisions.verCartas) && <Dropdown
                                                    classes={{ button: "w-100", dropdownMenu: "align-right" }}
                                                    styles={{button: {height: "38px", lineHeight: "0px"}, dropdownMenu: {zIndex: "99"}}}
                                                >
                                                    <button
                                                        className='dropdown-item'
                                                        data-toggle='tooltip'
                                                        data-placement='top'
                                                        title=''
                                                        data-original-title='Print'
                                                        onClick={() => window.open(getLink(`/imprimir/cartas/${carta.id}`), '_blank')}>
                                                        Imprimir
                                                    </button>

                                                    <button
                                                        className='dropdown-item'
                                                        data-toggle='tooltip'
                                                        data-placement='top'
                                                        title=''
                                                        data-original-title='Eliminar'
                                                        onClick={() => openDeleteModal(carta) }>
                                                        Eliminar
                                                    </button>
                                                </Dropdown>
                                            }</td>
                                        </tr>))
                                        : <tr className="tr-shadow"><td colSpan={5}>No hay ninguna carta creada.</td></tr>
                                    )
                                }
                            </tbody>
                        </table>

                        {cartas?.links && (<Pagination links={cartas.links} meta={cartas.meta} getData={getCartas} />)}
                    </div>
                </div>
            </div>
        </div>

        <Modal
            title={`Eliminar carta`}
            show={showDeleteModal}
            blank={false}
            callback={eliminarCarta}
            toggle={closeDeleteModal}>
                {
                    deleting 
                    ? <><Loader /></> 
                    : <p className="px-3 pb-3">¿Estás seguro que desea eliminar esta carta? (Esta acción no se puede deshacer).</p>
                }
        </Modal>

        <Modal
            title={`Generar Carta`}
            show={showGenerarModal}
            blank={true}
            toggle={closeGenerarModal}>
                <CrearCartaForm toggle={closeGenerarModal}></CrearCartaForm>
        </Modal>
    </>;
};

export default Cartas;
